import React, { useState, useContext } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth_context.js';
import media from '../../util/img_loader';
import '../../styles/profile/login.css';

function Body_login() {
    const [form, setForm] = useState({
        email: '',
        password: '',
        stayLoggedIn: false,
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        try {
            const response = await fetch('https://nurleder.de/api/login/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: form.email,
                    password: form.password
                }),
                credentials: 'omit' // wichtig: kein Cookie oder CSRF-Token
            });

            const data = await response.json();

            if (!response.ok) {
                const errMsg = data?.error || '❌ Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.';
                setErrorMessage(errMsg);
                return;
            }

            login(data.user);  // AuthContext aufrufen
            navigate('/');     // zur Startseite
        } catch (error) {
            console.error('Login-Fehler:', error);
            setErrorMessage('❌ Netzwerkfehler. Bitte später erneut versuchen.');
        }
    };


    return (
        <div className="login-container">
            <img src={media['logo/logo.png']} alt="Logo" className="logo" />
            {errorMessage && <p className="login-error">{errorMessage}</p>}
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Login</h2>

                <label className="input-label">E-Mail-Adresse</label>
                <input
                    type="email"
                    name="email"
                    placeholder="E-Mail"
                    value={form.email}
                    onChange={handleChange}
                    required
                />

                <label className="input-label">Passwort</label>
                <div className="password-field">
                    <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        placeholder="Passwort"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />
                    <span className='toggle-password' onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <label className="stay-logged">
                    <input
                        type="checkbox"
                        name="stayLoggedIn"
                        checked={form.stayLoggedIn}
                        onChange={handleChange}
                    />
                    Eingeloggt bleiben
                </label>

                <a href="/forgot-password" className="forgot-link">Passwort vergessen?</a>

                <button type="submit" className="login-button">Einloggen</button>
                <button type="button" className="register-button" onClick={() => navigate('/register')}>
                    Registrieren
                </button>
            </form>
        </div>
    );
}

export default Body_login;
